import ActionNode from './ActionNode'

class ActionNodeIntegration extends ActionNode {
  constructor(model) {
    super(model)
    this.value = model.value.data
    this.text = model.value.text
    this.icon = {
      ...this.icon,
      ...model.value.icon
    }
  }

  changeValue({ data, text, icon }) {
    this.value = data
    this.text = text
    this.icon = {
      ...this.icon,
      ...icon
    }
  }
}

export default ActionNodeIntegration



// WEBPACK FOOTER //
// ./src/utils/models/node/ActionNodeIntegration.js